import { RUBRICS } from '~/constants';
export const MENU_BAR = [
    {
        title: 'Рейтинги',
        to: '/ratings',
        isPullout: true,
    },
    {
        title: 'Видео',
        to: '/video',
        isPullout: true,
    },
    {
        title: 'Life',
        to: '/forbeslife',
        isPullout: false,
    },
    {
        title: 'Woman',
        to: '/forbes-woman',
        isPullout: false,
    },
    {
        title: 'Sport',
        to: '/sport',
        isPullout: false,
    },
    {
        title: 'Young',
        to: '/young',
        isPullout: false,
    },
];
export const MENU_BAR_DOTS = [
    {
        title: 'Образование',
        to: 'https://education.forbes.ru',
        isPullout: false,
    },
    {
        title: 'Club',
        to: 'https://club.forbes.ru',
        isPullout: true,
    },
    // {
    //   title: 'События',
    //   to: 'https://fcongress.forbes.ru/',
    //   isPullout: false,
    // },
    // {
    //   title: 'Журнал',
    //   to: '//podpiska.burda.ru/magazine/forbes',
    // },
];
export const MENU_RUBRICS = [
    ...JSON.parse(JSON.stringify(RUBRICS))?.map((item) => {
        item.withArticles = true;
        return item;
    }),
    {
        title: 'Экспертиза',
        to: 'https://blogs.forbes.ru',
    },
    {
        title: 'Новая реальность',
        to: 'https://www.forbes.ru/special/newreality',
    },
    {
        title: 'Подкасты',
        to: '/podcasts',
    },
    {
        title: 'Спецпроекты',
        to: '/special',
    },
];
export const ARCHIVE_RUBRICS = JSON.parse(JSON.stringify(MENU_RUBRICS))
    ?.filter(({ to }) => !to?.startsWith('http'))
    ?.map(({ title, to }) => {
    to = '/archive' + to;
    return {
        title,
        to,
    };
});
export const ARCHIVE_OTHER = JSON.parse(JSON.stringify([...MENU_BAR, ...MENU_BAR_DOTS]))
    ?.filter(({ to }) => !to?.startsWith('http'))
    ?.map(({ title, to }) => {
    to = '/archive' + to;
    return {
        title,
        to,
    };
});
export const ARCHIVE_INDEX = [
    {
        title: 'Рубрики',
        to: '/archive/rubrics',
        children: [...ARCHIVE_RUBRICS],
    },
    {
        title: 'Блоги',
        to: '/archive/brandvoice',
        children: [],
        foldedChildren: [],
    },
    ...ARCHIVE_OTHER,
];
